import useFullScreen from "/src/hooks/useFullScreen";
import { useEffect } from "react";

function useFullScreenEditor (btn) {

    const { toggleFullScreen, toggleFullScreenF11 } = useFullScreen();

    //Hide sidebar when fullscreen
    const onFullScreenEventChange = (e) => {

        const sidebar = document.getElementById('sidebar');
        const sidebarContainer = document.getElementById('sidebar-container');
        // Need to modificate sidebarContainer width if hidden
        if (document.fullscreenElement) {
            sidebar.style.display = "none";
            sidebarContainer.style.width = "160px";
            btn.current.classList.add('exit');
        }
        else {
            sidebar.style.display = "flex";
            sidebarContainer.style.width = "220px";
            btn.current.classList.remove('exit');
        }
    }

    useEffect( () => {

        document.addEventListener('keydown', toggleFullScreenF11);
        document.onfullscreenchange = onFullScreenEventChange;

        return () => {
            document.onfullscreenchange = () => {}
            document.removeEventListener("keydown", toggleFullScreenF11)
        }
    }, []);

    return { toggleFullScreen }
}

export default useFullScreenEditor;